import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import Paper from "@material-ui/core/Paper";

import { useStyles } from "../../../../Components/CSS/TableStyle.css";
import AdminHeader from "../../../../Components/NavBar/Admin/AdminHeader/AdminHeader";
import CustomTableHead from "../../../../Components/Table/CustomTableHeader/CustomTableHeader";
import CustomTableFooter from "../../../../Components/Table/CutomTableFooter/CustomTableFooter";
import PageTitle from "../../../../Components/PageTitle/PageTitle";
import GradeFilter from "../GradeFilter/GradeFilter";
import CustomSiteLoader from "../../../../Components/CustomSiteLoader/CustomSiteLoader";
import CustomEmptyMessage from "../../../../Components/CustomEmptyMessage/CustomEmptyMessage";
import Axios from "axios";
import { url } from "../../../../Config/Config";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import GradeBody from "../GradeBody/GradeBody";
import AddGrade from "../AddGrade/AddGrade";
import { getAdminRefreshToken } from "../../../../Redux/Actions/actions";
import CustomBreadCrumbs from "../../../../Components/CustomBreadCrumbs/CustomBreadCrumbs";

class ViewGrade extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowsPerPage: 10,
      page: 0,
      search: {
        gradeName: "",
      },
      isEmpty: false,
      detailStatus: false,
      detailData: [],
      column: [
        { name: "S.N." },
        { name: "Grade Name" },
        { name: "Percentage From (%)" },
        { name: "Percentage To (%)" },
        { name: "Grade" },
        { name: "Actions" },
      ],
      grades: [],
    };
  }

  componentDidMount() {
    this.getGrades();
  }

  getGrades = async () => {
    try {
      const response = await Axios.get(`${url}/api/grades`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.grades.length !== 0) {
        this.setState({
          grades: response.data.grades,
          isEmpty: false,
        });
      } else {
        this.setState({
          grades: [],
          isEmpty: true,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getGrades();
      }
    }
  };

  handleDetailStatus = (detailData) => {
    this.setState({
      detailStatus: true,
      detailData,
    });
  };

  handleCancelDetail = () => {
    this.setState({
      detailStatus: false,
    });
  };

  handleSearch = (e) => {
    this.setState({
      search: {
        ...this.state.search,
        [e.target.name]: e.target.value,
      },
    });
  };

  handlePage = (e, newPage) => {
    this.setState({
      page: newPage,
    });
  };

  handleRowsPerPage = (e) => {
    this.setState({
      rowsPerPage: +e.target.value,
      page: 0,
    });
  };

  render() {
    const { classes } = this.props;
    const { rowsPerPage, page } = this.state;
    const filtered = this.state.grades.filter((subject) => {
      return (
        subject.name
          .toLowerCase()
          .indexOf(this.state.search.gradeName.toLowerCase()) !== -1
      );
    });
    return (
      <div className={classes.root}>
        <AdminHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />

          <CustomBreadCrumbs url={this.props.match.url} />
          <PageTitle title="Grades" refreshUrl={this.props.match.url} />
          <div style={{ fontSize: 20, fontWeight: "bold" }}>Add New Grade</div>
          <AddGrade getGrades={this.getGrades} />
          <br />
          {this.state.grades.length !== 0 && (
            <GradeFilter
              data={this.state.search}
              handleSearch={this.handleSearch}
            />
          )}
          <br />

          <div style={{ fontSize: 20, fontWeight: "bold" }}>Grade List</div>
          {this.state.grades.length !== 0 ? (
            <Paper>
              <TableContainer>
                <Table>
                  <CustomTableHead column={this.state.column} />

                  <TableBody>
                    {(rowsPerPage > 0
                      ? filtered.slice(
                          rowsPerPage * page,
                          rowsPerPage * page + rowsPerPage
                        )
                      : filtered
                    ).map((grade, index) => (
                      <GradeBody
                        data={grade}
                        key={index}
                        index={index}
                        handleDetailStatus={this.handleDetailStatus}
                        getGrades={this.getGrades}
                      />
                    ))}
                  </TableBody>

                  <CustomTableFooter
                    count={filtered.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onChangePage={this.handlePage}
                    onChangeRowsPerPage={this.handleRowsPerPage}
                  />
                </Table>
              </TableContainer>
            </Paper>
          ) : this.state.isEmpty ? (
            <CustomEmptyMessage />
          ) : (
            <CustomSiteLoader />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(ViewGrade)));
